import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
const Motion = motion;

const CAMPAIGN_START_DATE = new Date(2026, 5, 20, 0, 0, 0);
const CAMPAIGN_TARGET_DATE = new Date(2026, 6, 20, 0, 0, 0);

const CampaignCountdown = React.memo(({ color = "var(--design-primary)" }) => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const updateTimeLeft = () => {
      const now = new Date();
      const difference = CAMPAIGN_TARGET_DATE - now;

      if (now < CAMPAIGN_START_DATE || difference <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      setTimeLeft({
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      });
    };

    updateTimeLeft();

    const timer = setInterval(() => {
      updateTimeLeft();
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatNumber = (num) => String(num).padStart(2, '0');

  return (
    <div className="flex flex-wrap justify-center gap-x-6 md:gap-x-12 gap-y-8 mb-8">
      {[
        { label: 'Days', value: timeLeft.days },
        { label: 'Hours', value: timeLeft.hours },
        { label: 'Minutes', value: timeLeft.minutes },
        { label: 'Seconds', value: timeLeft.seconds },
      ].map((item, idx) => (
        <div key={item.label} className="flex flex-col items-center text-center relative">
          <Motion.div 
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false }}
            transition={{ delay: idx * 0.1 }}
            className="flex items-baseline gap-1 md:gap-2"
          >
            <span className="text-[clamp(2rem,6vw,6rem)] font-black leading-none tracking-tighter tabular-nums" style={{ color }}>
              {formatNumber(item.value)}
            </span>
            <span className="text-lg md:text-2xl font-serif italic text-text-muted opacity-30">
              {item.label.charAt(0)}
            </span>
          </Motion.div>
          <div className="h-px w-full bg-border-color mt-3 relative overflow-hidden">
            <Motion.div 
              initial={{ x: '-100%' }}
              whileInView={{ x: '0%' }}
              viewport={{ once: false }}
              transition={{ duration: 1.5, delay: idx * 0.1 }}
              className="absolute inset-0 opacity-20"
              style={{ backgroundColor: color }}
            />
          </div>
        </div>
      ))}
    </div>
  );
});

export default CampaignCountdown;
